import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { isPlatformBrowser } from "@angular/common";
import { Observable } from "rxjs";
import { AuthService } from "../../../core/service/auth.service";
import { CreateChatCallCenterRequest, CreateChatCallCenterResponse } from "../interfaces/create-chat-call-center.interface";
import { ChatActiveResponse } from "../interfaces/active-chat.interface";

@Injectable({
  providedIn: 'root'
})
export class CreateChatService {
  private readonly apiUrl = `${environment.socketUrl}`;
  private readonly isBrowser: boolean;
  private tokenUser: string | null;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.tokenUser = this.authService.getToken();
  }
  createChat(subject: string): Observable<CreateChatCallCenterResponse> {
    if (!this.isBrowser) {
      throw new Error('This service is only available in browser environment');
    }

    if (!this.tokenUser) {
      throw new Error('User must be authenticated to create a chat');
    }

    const chat: CreateChatCallCenterRequest = {
      clientName: this.getNameUser(),
      clientId: this.getUserId(),
      subject: subject,
      activeTime: 0,
      messages: [],
      status: "pending",
      agent: {
        _id: "",
        name: ""
      }
    };

    return this.http.post<CreateChatCallCenterResponse>(
      `${this.apiUrl}/chat`,
      chat,

    );
  }
  getChatActive(): Observable<ChatActiveResponse> {
    const chatId = this.getIdChatSessionStorage();
    if (!chatId) {
      throw new Error('No hay chat ID disponible en sessionStorage');
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.tokenUser}`,
      'Content-Type': 'application/json'
    });
    return this.http.get<ChatActiveResponse>(
      `${this.apiUrl}/chat/${chatId}`,
      { headers }
    );
  }

  getNameUser(): string {
    let nameUser = "";
    this.authService.getCurrentUser().subscribe((user) => {
      nameUser = user?.ua_name! + user?.ua_lastname!
    });
    return nameUser;
  }

  getUserId(): number {
    let idUser = 0;
    this.authService.getCurrentUser().subscribe((user) => {
      idUser = Number(user?.ua_id!);
    });
    return idUser;
  }
  setIdChatSessionStorage(idChat: string): void {
    if (idChat && idChat.trim() !== '') {
      sessionStorage.setItem('idChat', idChat);
    }
  }

  getIdChatSessionStorage(): string | null {
    const chatId = sessionStorage.getItem('idChat');
    return chatId && chatId !== 'null' && chatId !== 'undefined' ? chatId : null;
  }
}
